import { render, staticRenderFns } from "./CreateGlLevel2.vue?vue&type=template&id=43ffae7b&scoped=true&"
import script from "./CreateGlLevel2.vue?vue&type=script&lang=js&"
export * from "./CreateGlLevel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffae7b",
  null
  
)

export default component.exports